import React, { useState, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { List as ListComponent, useDrawer, DrawerButton, SplitButton } from 'src/mtska-frontend-app-component';
import { useGridApiRef } from '@mui/x-data-grid';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import ImportButton from '../../Import/components/ImportButton';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadAll } from 'src/mtska-frontend-data-provider/hooks/useLoadAll.hooks';

const dataImportProviderName = 'renters/installed';
const dataProviderName = 'renters/manageableinstalled';
const drawerRouteBase = 'installedmanagement';

const moduleName = "Renter Installed";

const List = (params) => {
    const { t } = useTranslation();
    const { userCapabilities, appConfiguration } = useContext(AppContext);
    const { activate } = useDrawer();
    const [importerVersion, setImporterVersion] = useState(appConfiguration.importer.version ?? null);

    const apiRef = useGridApiRef();
    const getSelected = () => {
        return [...apiRef.current.getSelectedRows()].map(([name]) => name);
    };
    const [selected, setSelected] = useState([]);
    const handleRowSelection = (newSelection) => {
        setSelected(newSelection);
        params.rowSelectionExternalListener && params.rowSelectionExternalListener(newSelection);
    };

    const { doAction, loadAll, items, total, loading, reloadCounter } = useDataProvider(dataProviderName);
    const [listFilterPageSort, setListFilterPageSort] = useState();
    const handleFilterPageSortChange = (model) => {
        setListFilterPageSort(model);
    }

    useLoadAll({ listFilterPageSort, loadAll, params, reloadCounter })

    const handleRowDoubleclick = (row) => {
        if (row.id.includes('_')) return;
        activate(drawerRouteBase + '/detail', { id: row.id });
    }


    return (
        <>
            {userCapabilities && userCapabilities[dataProviderName + '.list'] && (
                <>
                    <ListComponent
                        {...params}
                        onRowDoubleClick={(userCapabilities && userCapabilities[dataProviderName + '.view']) ? handleRowDoubleclick : () => { }}
                        onFilterPageSortChange={handleFilterPageSortChange}
                        items={items}
                        total={total}
                        loading={loading}
                        apiRef={apiRef}
                        enableSelection
                        rightButtons={[
                            // <DrawerButton
                            //     drawerRoute={drawerRouteBase + '/applyAction'}
                            //     className="button-new"
                            //     params={{
                            //         items: selected,
                            //         dataProviderName: dataProviderName
                            //     }}
                            //     label={t("Apply action")}
                            // // disabled={userCapabilities && !userCapabilities[dataProviderName + '.create']}
                            // />,
                            <SplitButton
                                selectedItems={selected}
                                actions={[
                                    {
                                        disabled: selected == 0 || (userCapabilities && !userCapabilities[dataProviderName + '.create']),
                                        disabledIfNoItemselected: false,
                                        icon: "faUpload",
                                        label: t('Apply action'),
                                        onClick: () => {
                                            activate(
                                                drawerRouteBase + '/applyAction',
                                                {
                                                    items: selected,
                                                    dataProviderName: dataProviderName
                                                },
                                            )
                                        }
                                    },
                                    {
                                        disabled: userCapabilities && !userCapabilities[dataProviderName + '.import'],
                                        icon: "faUpload",
                                        label: t('Import'),
                                        onClick: () => {
                                            activate('imports/list', {
                                                filters_original: {
                                                    items: [{
                                                        operator: "equals",
                                                        field: "model",
                                                        value: dataProviderName,
                                                    }]
                                                },
                                                filters: { items: selected },
                                                configDataProviderName: dataProviderName,
                                                currentDataProviderName: importerVersion === "ImporterFileMappingConstants" ? dataImportProviderName : dataProviderName,
                                                moduleName: moduleName,
                                            });
                                        }
                                    },
                                    {
                                        disabled: userCapabilities && !userCapabilities[dataProviderName + '.export'],
                                        disabledIfNoItemselected: false,
                                        icon: "faDownload",
                                        label: t('Export'),
                                        onClick: () => {
                                            activate(
                                                'wizards/download',
                                                {
                                                    dataProviderName: dataProviderName,
                                                    recipe: 'recipes.renter.installed',
                                                    recipes: {
                                                        'recipes.renter.installed': 'Installed',
                                                    }
                                                },
                                            )
                                        }
                                    },
                                ]}
                            />,

                        ]}
                        dataProviderName={dataProviderName}
                        title={moduleName}
                        rowSelectionExternalListener={handleRowSelection}
                        doAction={doAction}
                        treeData
                        treeDataDrawerRoutes={{ 'inspect': 'cars/detail', 'choose': 'installedmanagement/detail', 'contract': 'contracts/detail' }}
                    />
                </>
            )}
        </>
    );
};

export default List;


